import { types } from "../../types/types";
import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import { finishSpinner, startSpinner } from "../ui/spinner";
import { startAlerta } from "../ui/alertas";

export const fetchRecupero = (idAfiliado, setOpenModal) => async (dispatch) => {
    try {
        dispatch(startSpinner());        
        const response = await fetchConToken(`RecuperoAfiliado/traerPorAfiliado/${idAfiliado}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.abmRecuperoTraerSuccess,
                payload: body,
            });
        } else {
            throw body;
        }
        setOpenModal&& setOpenModal(false);
        dispatch(finishSpinner());
    } catch (error) {
        dispatch({ type: types.abmRecuperoTraerSuccess, payload: [] });
        dispatch(finishSpinner());
        handleErrorApi(
            dispatch,
            error,
            "Error al cargar Recupero.",
            "Ha ocurrido un error. Intente nuevamente"
        );
    }
};

export const guardarRecupero = (id, data, setOpenModal) => async (dispatch, getState) => {
    try {
        dispatch(startSpinner());        
        const response = id ? await fetchConToken(`RecuperoAfiliado/${id}`, data, "PUT")
                            : await fetchConToken(`RecuperoAfiliado`, data, "POST");
        const body = await response.json();
    
        if (response.ok) {
            dispatch(
            startAlerta(
                "Recupero guardado correctamente",
                "success",
                "Comando Exitoso"
            )
            );
            if(!id){
                const item = {
                    ...body, usuario: {idUsuario: getState().auth.idUsuario, userName: getState().auth.userName }
                }
                dispatch({
                    type: types.abmRecuperoTraerSuccess,
                    payload: [ item, ...getState().autorizaciones.recupero ]
                });
                setOpenModal&& setOpenModal(false);
                dispatch(finishSpinner());
            }else{
                dispatch( fetchRecupero(data.idAfiliado, setOpenModal) );
            }
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(
            dispatch,
            error,
            "Error al guardar un nuevo recupero.",
            "Ha ocurrido un error. Intente nuevamente"
        );
    }
};

export const eliminarRecupero = (id, setOpenModalAlta) => async (dispatch, getState) => {
    try {
        dispatch(startSpinner());        
        const response = await fetchConToken(`RecuperoAfiliado/${id}`, {}, "DELETE")
        const body = await response.json();
    
        if (response.ok) {
            dispatch(
            startAlerta(
                "Recupero eliminado correctamente",
                "success",
                "Comando Exitoso"
            )
            );
            dispatch({
                type: types.abmRecuperoTraerSuccess,
                payload: getState().autorizaciones.recupero.filter(s => s.id !== id)
            });
            setOpenModalAlta&& setOpenModalAlta(false);
            dispatch(finishSpinner());
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(
            dispatch,
            error,
            "Error al eliminar el registro de recupero.",
            "Ha ocurrido un error. Intente nuevamente"
        );
    }
};

export const fetchTrackingRecupero = (idOriginal) => async (dispatch) => {
    try {
        dispatch(startSpinner());
        const response = await fetchConToken(`RecuperoAfiliado/traerTracking/${idOriginal}`);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.trackingRecuperoTraerSuccess,
                payload: body,
            });
        } else {
            throw body;
        }
        dispatch(finishSpinner());
    } catch (error) {
        dispatch({ type: types.trackingRecuperoTraerSuccess, payload: [] });
        dispatch(finishSpinner());
        handleErrorApi(
            dispatch,
            error,
            "Error al cargar el Tracking Recupero.",
            "Ha ocurrido un error. Intente nuevamente"
            );
    }
};

export const fetchRecuperoSolicitud = (idSolicitud) => async (dispatch) => {
    try {
        dispatch(startSpinner());        
        const response = await fetchConToken(`RecuperoAfiliado/traerRecuperoSolicitud/${idSolicitud}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.recuperoSolicitudTraerSuccess,
                payload: body,
            });
        } else {
            throw body;
        }
        dispatch(finishSpinner());
    } catch (error) {
        dispatch({ type: types.recuperoSolicitudTraerSuccess, payload: [] });
        dispatch(finishSpinner());
        handleErrorApi(
            dispatch,
            error,
            "Error al cargar Recupero Solicitud.",
            "Ha ocurrido un error. Intente nuevamente"
        );
    }
};

